/**
 * EXÁMENES PAGE - Catálogo de Exámenes
 * Página independiente que reutiliza el componente ExamenesCatalogo de órdenes.
 */

import { useTranslation } from "react-i18next";
import { FlaskConical } from "lucide-react";
import { ExamenesCatalogo } from "./components/examenes-catalogo";

export default function ExamenesPage() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 sm:gap-6 p-4 sm:p-6">
      <div className="flex items-center gap-3">
        <FlaskConical className="h-6 w-6 sm:h-8 sm:w-8 text-primary" />
        <div>
          <h1 className="text-lg sm:text-2xl font-bold">{t("nav.examenes")}</h1>
          <p className="text-xs sm:text-sm text-muted-foreground">
            {t("examenes.description", "Gestiona el catálogo de exámenes y valores de referencia")}
          </p>
        </div>
      </div>
      <ExamenesCatalogo />
    </div>
  );
}
